import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TrailingColumnComponentProps } from './types';

export const trailingColumnStyles = ({ verticalAlign }: TrailingColumnComponentProps) => [
  css`
    display: flex;
    grid-area: trail;
    padding-left: ${theme.spacing(2)};
    justify-content: ${verticalAlign};
    flex-direction: column;
    align-items: flex-end;
    .trailing-column-child {
      font-size: ${verticalAlign === 'center' ? theme.fontSize(16) : theme.fontSize(14)};
      margin: 0;
      margin-bottom: ${theme.spacing(0.25)};
      text-transform: capitalize;
    }
  `,
  css`
    button {
      :hover:not([disabled]) {
        background-color: ${theme.colors.neutral20} !important; // hoverColor was theme.colors.neutral20
      }
    }
  `,
];
